export type InitialVoiceCallState = {
  open: boolean;
  sessionId: string | null;
};

export function getInitialVoiceCallState({
  voiceRequested,
  sessionId,
}: {
  voiceRequested: boolean;
  sessionId: string;
}): InitialVoiceCallState {
  return voiceRequested
    ? { open: true, sessionId }
    : { open: false, sessionId: null };
}

export function formatVoiceCallDuration(elapsedMs: number): string {
  const totalSeconds = Math.max(0, Math.floor(elapsedMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
